import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, enableMetaPixel, revokeMetaPixel } from "../lib/meta";
import { LEGAL_LINKS } from "../mock";

const PRIVACY_URL = (LEGAL_LINKS[0] && LEGAL_LINKS[0].url) || "/privacy";

// Minimal marketing-consent gate for the Meta Pixel: Accept / Reject,
// choice persisted, and re-openable to change later.
export default function ConsentBanner() {
  const [choice, setChoice] = useState(() => getConsent());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!getConsent()) setOpen(true);
  }, []);

  const accept = () => { setConsent(true); enableMetaPixel(); setChoice("yes"); setOpen(false); };
  const reject = () => { setConsent(false); revokeMetaPixel(); setChoice("no"); setOpen(false); };

  return (
    <>
      {open && (
        <div
          data-testid="cookie-consent-banner"
          className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-[560px] rounded-[16px] border border-[var(--cm-line)] bg-white p-5 shadow-[0_12px_40px_rgba(0,0,0,0.16)] sm:inset-x-auto sm:left-4 sm:bottom-4"
        >
          <p className="text-[0.82rem] font-semibold text-[var(--cm-ink)]">Cookie e marketing</p>
          <p className="mt-1.5 text-[0.82rem] leading-relaxed text-[#6f6f68]">
            Usiamo cookie di marketing (Meta) per misurare l'efficacia delle campagne.
            Puoi accettare o rifiutare; potrai cambiare scelta in qualsiasi momento.{" "}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
              Privacy
            </a>.
          </p>
          <div className="mt-4 flex gap-2.5">
            <button
              data-testid="cookie-accept-btn"
              onClick={accept}
              className="flex-1 rounded-full bg-[var(--cm-ink)] px-5 py-2.5 text-[0.85rem] font-medium text-white transition-transform hover:scale-[1.01]"
            >
              Accetta
            </button>
            <button
              data-testid="cookie-reject-btn"
              onClick={reject}
              className="flex-1 rounded-full border border-[var(--cm-line)] px-5 py-2.5 text-[0.85rem] font-medium text-[var(--cm-ink)] transition-colors hover:border-[var(--cm-ink)]"
            >
              Rifiuta
            </button>
          </div>
        </div>
      )}
      {!open && choice && (
        <button
          data-testid="cookie-preferences-btn"
          onClick={() => setOpen(true)}
          aria-label="Preferenze cookie"
          className="fixed bottom-3 left-3 z-[60] flex h-10 w-10 items-center justify-center rounded-full border border-[var(--cm-line)] bg-white text-[#6f6f68] shadow-md transition-colors hover:text-[var(--cm-ink)]"
        >
          <Cookie size={17} />
        </button>
      )}
    </>
  );
}
